<modal-container #modal [headerTitle]="'modalAddressCreate.title'" [isLargeModal]="true" [isHideBtnHidden]="true">
  <ng-container class="modal-button-show"></ng-container>
  <ng-container class="modal-body-content">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      <div class="row">
        <div class="col-12">
          <form-row-input
            [label]="'modalAddressCreate.addressName'"
            [required]="true"
            [inputType]="'text'"
            [(model)]="addressName"
          ></form-row-input>
        </div>
        <div class="col-6">
          <form-row-input
            [label]="'modalAddressCreate.street'"
            [required]="true"
            [inputType]="'text'"
            [(model)]="street"
          ></form-row-input>
        </div>
        <div class="col-6">
          <form-row-input
            [label]="'modalAddressCreate.streetNumber'"
            [required]="true"
            [inputType]="'text'"
            [(model)]="streetNumber"
          ></form-row-input>
        </div>
        <div class="col-6">
          <form-row-input
            [label]="'modalAddressCreate.city'"
            [required]="true"
            [inputType]="'text'"
            [(model)]="city"
          ></form-row-input>
        </div>
        <div class="col-6">
          <form-row-input
            [label]="'modalAddressCreate.zip'"
            [required]="true"
            [inputType]="'text'"
            [(model)]="zip"
          ></form-row-input>
        </div>
        <div class="col-12">
          <form-row-input
            [label]="'modalAddressCreate.phone'"
            [required]="true"
            [inputType]="'text'"
            [(model)]="phone"
          ></form-row-input>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container class="modal-footer-content">
    <btn
      [label]="'modalAddressCreate.btn'"
      [title]="'modalAddressCreate.btn' | translate"
      (onEvent)="createAddress()"
      [classes]="['btn', 'btn-first']"
      data-cy="submit"
    ></btn>
  </ng-container>
</modal-container>
